import { useEffect } from "react";

interface Props {
  message: string | null;
  onClose: () => void;
}

export default function Toast({ message, onClose }: Props) {
  useEffect(() => {
    if (!message) return undefined;
    const timer = setTimeout(onClose, 2800);
    return () => clearTimeout(timer);
  }, [message, onClose]);

  if (!message) return null;

  return (
    <div className="fixed bottom-6 left-1/2 z-[100] -translate-x-1/2 px-4 animate-fade-up" role="status">
      <div className="flex items-center gap-2 rounded-full border border-secondary-700 bg-secondary-900 px-5 py-3 text-sm text-background-50">
        <i className="ri-information-line text-primary-400 text-base" aria-hidden="true" />
        <span className="whitespace-nowrap">{message}</span>
      </div>
    </div>
  );
}